import { A11yMenu } from './A11yMenu';
import { useEffect } from 'react';
import { useStore } from '@hmpu/powerups.store';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { AudioDescriptionsAnnouncer } from '@hmpu/powerups.ui.a11y.audio-descriptions-announcer';
import useResetFocus from '../../../hooks/useResetFocus';

export function AccessibilitySettings() {
  const { __t } = useTranslation('A11Y_MENU');
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const pageTitle = __t('pageTitle');
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);

  useEffect(() => {
    const backButton = document.querySelector("#SettingsPanel-Back") as HTMLElement | null;
    if (backButton) {
      backButton.focus();
    }   
    setPageTitle(pageTitle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  return (
    <>
      <AudioDescriptionsAnnouncer />
      <A11yMenu />
    </>
  );
}
